const CORRECTION_REQUESTS = {
  address: 'address',
  addressProof: 'address_proof',
  addressProofRenewal: 'address_proof_renewal',
  curp: 'curp',
  expiredIdentification: 'expired_identification',
  identification: 'identification',
  w8Contract: 'w8_contract'
};

export default CORRECTION_REQUESTS;
